import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import HeadContainer from '../../../../../common/head-container';

const OTP_LENGTH = 6;
const MAX_RESEND_COUNT = 2;
const MAX_ATTEMPTS = 3;

const OtpComponent = ({
  setScreenNumber,
  phoneNumber,
  handleChangePhoneNumber,
  successSendOtp,
  attemptsExhausted
}) => {
  const [otp, setOtp] = useState(new Array(OTP_LENGTH).fill(''));
  const [timeLeft, setTimeLeft] = useState(60);
  const [isResendAvailable, setIsResendAvailable] = useState(false);
  const [resendCount, setResendCount] = useState(0);
  const [attemptsCount, setAttemptsCount] = useState(0);
  const [error, setError] = useState(false);
  const inputsRef = useRef([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    }

    setIsResendAvailable(true);
  }, [timeLeft]);

  const handleResend = () => {
    if (resendCount >= MAX_RESEND_COUNT) return;

    setResendCount(resendCount + 1);
    setTimeLeft(60);
    setIsResendAvailable(false);
  };

  const handleChange = (event, index) => {
    const value = event.target.value;

    if (value.length === OTP_LENGTH) {
      setOtp(value.split('').slice(0, OTP_LENGTH));
      return;
    }

    if (!isNaN(value) && value.length === 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (index < OTP_LENGTH - 1) inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === 'Backspace') {
      const newOtp = [...otp];
      newOtp[index] = '';
      setOtp(newOtp);

      if (index > 0) inputsRef.current[index - 1]?.focus();
    } else if (event.key >= '0' && event.key <= '9') {
      if (otp[index] !== '' && index < OTP_LENGTH - 1) {
        event.preventDefault();

        const newOtp = [...otp];
        newOtp[index + 1] = event.key;
        setOtp(newOtp);
        inputsRef.current[index + 1]?.focus();
      }
    }
  };

  const onSubmit = () => {
    if (otp.join('').length === OTP_LENGTH) {
      successSendOtp();
      return;
    }

    const nextAttempt = attemptsCount + 1;
    setAttemptsCount(nextAttempt);
    setError(true);

    if (nextAttempt >= MAX_ATTEMPTS) attemptsExhausted();
  };

  useEffect(() => {
    if (!('OTPCredential' in window)) return;

    const abortController = new AbortController();

    navigator.credentials
      .get({ otp: { transport: ['sms'] }, signal: abortController.signal })
      .then((otpCredential) => {
        if (otpCredential?.code) {
          setOtp(otpCredential.code.split('').slice(0, OTP_LENGTH));
        }
      })
      .catch(() => {});

    return () => abortController.abort();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <HeadContainer setScreenNumber={setScreenNumber} />
        <div className={styles.content}>
          <p className={styles.title}>
            {`Ми надіслали повідомлення на номер ${
              phoneNumber || '380*********'
            }`}
          </p>
          <p className={styles.description}>
            Для підтвердження номеру введи код із SMS
          </p>
          <form
            onSubmit={(event) => {
              event.preventDefault();
              onSubmit();
            }}
          >
            <div className={styles.otpContainer}>
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={(element) => (inputsRef.current[index] = element)}
                  type="number"
                  inputMode="numeric"
                  maxLength="1"
                  value={digit}
                  onKeyDown={(event) => handleKeyDown(event, index)}
                  onChange={(event) => handleChange(event, index)}
                  onFocus={() => setError(false)}
                  autoComplete="one-time-code"
                  className={classNames(error && styles.errorInput)}
                />
              ))}
            </div>
          </form>
          {resendCount < MAX_RESEND_COUNT &&
            (isResendAvailable ? (
              <button className={styles.resendButton} onClick={handleResend}>
                Повторно отримати код
              </button>
            ) : (
              <p className={styles.timer}>
                Отримати код повторно через{' '}
                {String(Math.floor(timeLeft / 60)).padStart(2, '0')}:
                {String(timeLeft % 60).padStart(2, '0')}
              </p>
            ))}
          <div className={styles.buttonContainer}>
            {error && (
              <p className={styles.error}>Перевір коректність введеного коду</p>
            )}
            <button className={styles.blueButton} onClick={onSubmit}>
              <span>Надіслати</span>
            </button>
            <button
              className={styles.whiteButton}
              onClick={handleChangePhoneNumber}
            >
              Змінити номер
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpComponent;
